import { Grid } from '@mui/material';
import GlobalSearcher, { Filter } from 'lib/common/GlobalSearcher';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getBusinessTgDebt } from '../../../../../lib/api';
import { getFiscalDebtCertificate } from '../../../../../lib/api/fiscalDebt';
import CustomAlert from '../../../../../lib/designSystem/Alert';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from '../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../lib/designSystem/Table';

const TGRDebts: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [tgrData, setTgrData] = useState<any>({});
  const [loadingCertificate, setLoadingCertificate] = useState(false);
  const [errorCertificate, setErrorCertificate] = useState(false);
  const [active, setActive] = useState('true');

  const { id } = useParams<{ id: string }>();

  const generateQuery = () => {
    let query = '';
    if (active) query += `active=${active}&`;
    return query;
  };

  const fetchTgrData = async () => {
    if (!id) return;
    const query = generateQuery();
    const tgrDataResponse = await getBusinessTgDebt(dispatch, id, query);
    setTgrData(tgrDataResponse || []);
  };

  const setUp = async () => {
    setLoading(true);
    await fetchTgrData();
    setLoading(false);
  };

  const triggerSearch = async () => {
    setLoading(true);
    await fetchTgrData();
    setLoading(false);
  };

  const handleDownloadStatement = async () => {
    setLoadingCertificate(true);
    const url = await getFiscalDebtCertificate(dispatch, id as string);
    if (url) {
      window.open(url, '_blank');
    } else {
      setErrorCertificate(true);
    }
    setLoadingCertificate(false);
  };

  const filters: Filter[] = [
    {
      label: 'Vigencia',
      type: 'select',
      value: active,
      setter: setActive,
      options: [
        { label: 'Actual', value: 'true' },
        { label: 'Histórico', value: 'false' },
      ],
    },
  ];

  const buttons: CustomButtonProps[] = [
    {
      name: 'Filtro',
      action: () => {},
      color: 'primary',
      customButton: (
        <GlobalSearcher
          filters={filters}
          triggerSearch={triggerSearch}
          dispatch={dispatch}
          disableSearch={loading}
        />
      ),
    },
    {
      name: 'Descargar cartola',
      action: handleDownloadStatement,
      color: 'primary',
      disabled: loadingCertificate,
    },
    // {
    //   name: filter === 'actual' ? 'Ver histórico' : 'Ver vigente',
    //   action: handleChange,
    //   color: 'primary',
    // },
  ];

  useEffect(() => {
    void setUp();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <HeaderWithActions
            title="Acá encontrarás el historial de deuda fiscal de la empresa."
            buttons={buttons}
            variant="body1"
          />
          <EnhancedTable
            finalSumRow
            exportToFile="xlsx"
            tableSize="small"
            dataHeaders={[
              { key: 'folio', label: 'Folio' },
              { key: 'form', label: 'Formulario' },
              { key: 'dueDate', label: 'Vencimiento', type: 'date' },
              { key: 'amount', label: 'Deuda neta', type: 'money' },
              { key: 'adjust', label: 'Reajuste ', type: 'money' },
              { key: 'interest', label: 'Interés', type: 'money' },
              { key: 'penalty', label: 'Multa', type: 'money' },
              { key: 'total', label: 'Total', type: 'money' },
              { key: 'agreementMessage', label: 'Convenio' },
              { key: 'proceedingMessage', label: 'Cobranza' },
              { key: 'debtStatus', label: '', type: 'debt-status' },
            ]}
            data={tgrData}
            rowsPerPageDefault={100}
            lastElement
          />
        </Grid>
      </Grid>
      <CustomAlert
        open={errorCertificate}
        severity="error"
        text="No hay cartola fiscal disponible."
        onClose={() => setErrorCertificate(false)}
      ></CustomAlert>
    </>
  );
};

export default TGRDebts;
